import React, { Component } from 'react'
import { Link } from "react-router-dom"

import logo_black from 'static/images/icons/cellwine-logo-black.svg'

class EmptyHeader extends Component {
	render() {
		return (
			<div className="row bg-white">
                <div className="container">
                    <div className="row">
                        <div className="col-12" style={{padding: '10px 0'}}>
                            <Link to="/">
                                <img className="header-logo" src={logo_black} />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
		)
	}
}

export default EmptyHeader
